'use strict';

import _ from 'lodash';

import './ValidatedInput.less';

const EmailVerifier = require('ck-core/source/verifiers/user/EmailVerifier');
const Language = require('ck-core/source/services/Language');
const CKImage = require('./image');
const Verifier = require('ck-core/source/system/Verifier');

const Mailcheck = require('mailcheck');
_.remove(Mailcheck.defaultSecondLevelDomains, domain => domain === 'hotmail');
Mailcheck.defaultDomains.push('hotmail.com');

const ELEMENT_TYPES = {
	DATE: 'date',
	SELECT: 'select',
	MULTILINE: 'multiline',
	RADIO: 'radio',
	CREDIT_CARD_DATE: 'creditCardDate',
	CHECKBOX: 'checkbox',
	FILE: 'file',
	EMAIL: 'email',
	SPINNER: 'spinner'
};

const ValidatedInput = (module.exports = require('./Component').define(
	require('ck-core/source/system/EventContrib')(),
	{
		init_ValidatedInput: function(options) {
			this.options = options = _.defaults(options || {}, {
				name: '',
				label: '',
				placeholder: '',
				validate: null,
				elementValue: '',
				elementType: '',
				readonly: false,
				attr: null,
				// For elementType === 'select'
				choices: {},
				form: null,
				fileMode: 'text',
				mask: null,
				optional: false,
				verifierOptions: null,
				noValidityUi: false,
				autocompleteValues: null,

				hideWhenInactive: false,
				disableWhenInactive: false,

				datesForAges: true
			});

			this.name = options.name;

			this.dom = $('<div class="validatedInput row">');

			this.dom.data('validatedInput', this);

			this.CHANGE_EVENTS = 'change keyup';

			if (options.label) {
				this.label = $('<label>')
					.attr('for', this.name)
					.html(options.label)
					.appendTo(this.dom);

				if (options.optional) {
					this.optionalLabel = $('<div class="optionalLabel">')
						.html('Optional')
						.appendTo(this.label);
				}
			}

			const CUSTOM_UI = _.values(ELEMENT_TYPES);

			if (_.includes(CUSTOM_UI, options.elementType)) {
				this['draw_' + options.elementType](options);
			} else {
				this.draw_default(options);
			}

			if (this.inputElement) {
				if (options.readonly) {
					this.inputElement.attr('readonly', 'readonly');
				}
				if (options.mask) {
					// Allow passing mask as an array or single element

					this.inputElement.mask.apply(this.inputElement, _.flatten([options.mask]));
				}

				_.each(options.attr, (value, key) => {
					this.inputElement.attr(key, value);
				});
			}

			this.status = $('<div class="status">').appendTo(this.dom);
			this.warning = $('<div class="warning">')
				.appendTo(this.dom)
				.hide();
			if (!options.validate) {
				this._validity = {
					status: Verifier.STATUS.VALID
				};
			} else {
				this.validate = options.validate;
			}
			this.radioGroup = options.radioGroup;
			this.elementType = options.elementType;
			this.checkCount = 0;
			this.changed = false;
			this.initialValue = options.elementValue;

			if (this.initialValue === undefined) {
				this.initialValue = this.getValue();
			}

			if (options.elementValue) {
				this.setValue(options.elementValue, true);
				this.onChange(false);
			}

			if (options.noValidityUi) {
				this.status.hide();
				this.warning.hide();
			}
		},

		/* Whether the validatedInput is enabled and relevant to the form. For
	example, it is inactive if it is enabled but not in the current selected
	radio group. In this case, it passes validity check even if it contains an
	invalid value */
		isActive: function() {
			if (this.options.activeWhen) {
				return this.options.activeWhen();
			} else if (this.radioGroup) {
				// Only support one group

				var groupKey = _.keys(this.radioGroup)[0];

				var groupValue = this.form.fields[groupKey];

				let expected = this.radioGroup[groupKey];

				if (!groupValue) return false;
				if (_.isArray(expected)) {
					return _.includes(expected, groupValue);
				} else {
					return groupValue === expected;
				}
			}

			return true;
		},

		draw_select: function(options) {
			this.inputElement = $('<select>')
				.attr('name', this.name)
				.on(this.CHANGE_EVENTS, this.onChange.bind(this, false))
				.appendTo(this.dom);

			this.setChoices(options.choices);
		},

		setChoices: function(choices) {
			this.inputElement.empty();

			_.each(choices, (text, value) => {
				var choice = $('<option>')
					.attr('value', value)
					.text(text);

				if (this.elementValue === value) {
					choice.attr('selected', 'selected');
				}
				this.inputElement.append(choice);
			});
		},

		draw_multiline: function(options) {
			this.inputElement = $('<textarea>')
				.attr('name', this.name)
				.attr('placeholder', options.placeholder)
				.on(
					this.CHANGE_EVENTS,
					_.debounce(this.onChange.bind(this, false), ValidatedInput.DEBOUNCE_INTERVAL)
				)
				.appendTo(this.dom);
		},

		draw_date: function(options) {
			this.dom.addClass('date');
			this.monthElement = $('<select name="month" class="month">')
				.append('<option value="" disabled selected>Month</option>')
				.on(this.CHANGE_EVENTS, this.onChange.bind(this, false))
				.appendTo(this.dom);

			_.each(require('./ValidatedInputLang').MONTHS, (month, i) => {
				this.monthElement.append(
					$('<option>')
						.attr('value', i)
						.text(month)
				);
			});

			this.dayElement = $('<select name="day" class="day">')
				.append('<option value="" disabled selected>Day</option>')
				.on(this.CHANGE_EVENTS, this.onChange.bind(this, false))
				.appendTo(this.dom);

			for (let i = 1; i <= 31; i++) {
				this.dayElement.append(
					$('<option>')
						.attr('value', i)
						.text(i)
				);
			}

			this.yearElement = $('<select name="year" class="year">')
				.append('<option value="" disabled selected>Year</option>')
				.on(this.CHANGE_EVENTS, this.onChange.bind(this, false))
				.appendTo(this.dom);

			if (options.minYear) {
				const safeMax = Math.max(options.minYear, Math.min(options.minYear + 100, options.maxYear));

				for (let i = options.minYear; i <= safeMax; i++) {
					this.yearElement.append(
						$('<option>')
							.attr('value', i)
							.text(i)
					);
				}
			} else {
				for (
					let i = moment().year() + (options.datesForAges ? -5 : 1);
					i > moment().year() - 100;
					i--
				) {
					this.yearElement.append(
						$('<option>')
							.attr('value', i)
							.text(i)
					);
				}
			}

			if (options.readonly) {
				this.monthElement.attr('disabled', 'disabled');
				this.dayElement.attr('readonly', 'readonly');
				this.yearElement.attr('readonly', 'readonly');
			}
		},

		draw_checkbox: function() {
			this.inputElement = $('<div class="checkbox">')
				.attr('name', this.name)
				.append(CKImage('tick-white'))
				.appendTo(this.dom);

			this.inputElement.on('tap', () => {
				this.inputElement.toggleClass('selected');

				this.onChange();
			});
		},

		draw_radio: function(options) {
			this.dom.addClass('radio');
			this.group = options.group;

			this.radioButton = $('<div class="radioButton">')
				.append(CKImage('tick-green'))
				.prependTo(this.dom);
			this.dom.tap(() => {
				if (!this.radioButton.hasClass('selected')) {
					this.setGroupValue(this.name);

					this.publish('verify', this.name);
				}
			});
			if (this.elementValue) {
				this.setGroupValue(this.name);
			}
		},

		draw_spinner: function(options) {
			this.dom.addClass('spinner');
			this.minusButton = $('<div class="minus greyCircle">').append('-');
			this.plusButton = $('<div class="plus greyCircle">').append('+');
			this.number = $('<div class="number">').append(options.elementValue || 0);
			this.dom.append(
				$('<div class="control">').append(this.minusButton, this.number, this.plusButton)
			);

			this.minusButton.on('mousedown', e => {
				e.preventDefault();
			});

			this.plusButton.on('mousedown', e => {
				e.preventDefault();
			});

			this.minusButton.on('tap', e => {
				const DEFAULT_MIN = 0;

				let value = Math.max(this.options.spinnerMinimum || DEFAULT_MIN, this.getValue() - 1);
				this.number.html(value);
				this.onChange();

				e.preventDefault();
			});

			this.plusButton.on('tap', e => {
				const DEFAULT_MAX = 5;

				let value = Math.min(this.options.spinnerMaximum || DEFAULT_MAX, this.getValue() + 1);
				this.number.html(value);
				this.onChange();

				e.preventDefault();
			});
		},

		_appendGenericInputElement: function() {
			this.inputElement = $('<input>')
				.attr('name', this.name)
				.attr('placeholder', this.options.placeholder)
				.on(
					this.CHANGE_EVENTS,
					_.debounce(this.onChange.bind(this, false), ValidatedInput.DEBOUNCE_INTERVAL)
				)
				.appendTo(this.dom);
		},

		draw_email: function() {
			this._appendGenericInputElement();

			this.inputElement.attr('type', 'email');
			this.inputElement.attr('autocomplete', 'email');

			const suggestionDom = $('<div>').addClass('suggestion');

			this.dom.append(suggestionDom);

			this.inputElement.on('blur', () => {
				Mailcheck.run({
					email: this.getValue(),
					suggested: suggestion => {
						// Move the suggestionDom to be after the status and warning divs to not break styling
						if (!suggestionDom.is(':last-child')) {
							suggestionDom.nextAll().after(suggestionDom);
						}

						suggestionDom.empty();
						suggestionDom.html(
							Language.mapVariables(
								require('./ValidatedInputLang').VALIDATED_INPUT.EMAIL.SUGGESTION,
								{
									suggestion: suggestion.full
								}
							)
						);

						suggestionDom.find('a').one('tap', event => {
							const suggestion = $(event.target).text();

							CK.trackAnalytic('MailcheckSuggestionUsed', {
								old: this.getValue(),
								new: suggestion
							});

							this.setValue(suggestion);
							suggestionDom.empty();
						});
					},
					empty: () => {
						suggestionDom.empty();
					}
				});
			});

			if (!this.options.validate) {
				this.options.validate = new EmailVerifier(this.options.verifierOptions);
			}
		},

		draw_default: function(options) {
			this._appendGenericInputElement();
			if (options.elementType) {
				this.inputElement.attr('type', options.elementType);

				if (this.options.validate) {
					// TODO: This is done here asynchronously but ideally draw should be assumed async and the other code refactored
					this.validate = this.options.validate;
					this._validity = undefined;
				}
			}

			if (options.autocompleteValues) {
				this.inputElement
					.autocomplete({
						source: options.autocompleteValues
					})
					.data('ui-autocomplete')._renderItem = function(ul, item) {
					return $('<li></li>')
						.data('item.autocomplete', item)
						.append($('<div>').append(item.label))
						.appendTo(ul);
				};
			}

			if (options.elementValue) {
				if (options.elementType === 'datePicker') {
					options.elementValue = CK.fn.dateToCalendar(options.elementValue);
				} else if (options.elementType === 'password') {
					options.elementValue = '***';
				}
			}
		},

		draw_file: function(options) {
			var t = this;
			var updateValue = e => {
				this.setValue(e.target.result);
			};
			this.inputElement = $('<input type="file">')
				.attr('name', this.name)
				.on('change', this.inputElement, function() {
					var files = this.files;

					if (options.fileMode === 'text') {
						var reader = new FileReader();

						reader.onload = updateValue;

						reader.readAsText(files[0]);
					} else {
						t.setValue(files[0]);
					}
				})
				.appendTo(this.dom);
		},

		setEnabled: function(enabled) {
			switch (this.elementType) {
				case ELEMENT_TYPES.DATE:
					this.monthElement.attr('disabled', !enabled);
					this.dayElement.attr('disabled', !enabled);
					this.yearElement.attr('disabled', !enabled);
					break;

				case ELEMENT_TYPES.SPINNER: {
					if (enabled) {
						this.plusButton.css({
							'pointer-events': ''
						});
						this.minusButton.css({
							'pointer-events': ''
						});
					} else {
						this.plusButton.css({
							'pointer-events': 'none'
						});
						this.minusButton.css({
							'pointer-events': 'none'
						});
					}

					break;
				}

				case ELEMENT_TYPES.CHECKBOX: {
					if (enabled) {
						this.inputElement.css({
							'pointer-events': ''
						});
					} else {
						this.inputElement.css({
							'pointer-events': 'none'
						});
					}

					break;
				}

				default:
					this.inputElement.attr('disabled', !enabled);
					break;
			}
		},

		getGroup: function() {
			if (this.group && this.form) {
				return this.form.groups[this.group];
			}
		},
		setGroupValue: function(value) {
			if (this.group && this.form) {
				this.form.fields[this.group] = value;

				_.each(this.form.groups[this.group], input => {
					input.setValue(input.name === value);
				});
			}
		},
		getBootstrapDom: function(options) {
			if (this.elementType === 'radio') {
				return this.dom;
			}

			if (this.bootstrapDom) {
				return this.bootstrapDom;
			}

			options = _.defaults(options || {}, {
				offset: 1,

				labelColumnSize: 2,

				inputColumnSize: 5
			});
			var label = $('<div class="bootstrap">')
				.addClass('col-sm-' + options.labelColumnSize + ' col-sm-offset-' + options.offset)
				.append(this.label);

			var input = $('<div class="bootstrap">')
				.addClass('col-sm-' + options.inputColumnSize)
				.append(this.dom.removeClass('row'));

			this.bootstrapDom = $('<div class="row">')
				.append(label)
				.append(input);

			return this.bootstrapDom;
		},

		hasChanged: function() {
			return this.changed && this.getValue() !== this.initialValue;
		},

		onChange: function(quiet, force) {
			// Fields that are invalid (such as Dates) can return undefined, even
			// if the user has changed the invalid value
			if (!force && this.previousValue === this.getValue() && this.previousValue !== undefined) {
				return;
			}

			this.previousValue = this.getValue();
			this.changed = true;

			var checkCount = ++this.checkCount;

			if (this.form) {
				this.form.publish('update', {
					name: this.name,
					value: this.getValue()
				});
			}

			this.publish('update', {
				name: this.name,
				value: this.getValue()
			});

			if (!this.validate) {
				return;
			}

			let output;

			if (Verifier.isInstance(this.validate)) {
				output = this.validate.verify(this.getValue(), false, this);
			} else {
				output = this.validate(this.getValue(), this);
			}

			if (output && output.then) {
				output
					.then(result => {
						this.onVerify(checkCount, result, quiet);
					})
					.catch(err => {
						this.onVerify(
							checkCount,
							{
								status: Verifier.STATUS.INVALID,
								message: _.get(err, 'tags.reason') || err.message
							},
							quiet
						);
					});
			} else if (_.isObject(output)) {
				this.onVerify(checkCount, output, quiet);
			} else {
				this.onVerify(
					checkCount,
					{
						status: output ? Verifier.STATUS.VALID : Verifier.STATUS.INVALID
					},
					quiet
				);
			}
		},

		onVerify: function(checkCount, result, quiet) {
			if (checkCount !== this.checkCount) return this._validity;

			this._validity = result;

			if (quiet) {
				this.warning.hide();
			} else {
				if (result.message) {
					this.warning.html(result.message).show();
					if (result.status === Verifier.STATUS.VALID) {
						this.warning.addClass('verified');
					} else {
						this.warning.removeClass('verified');
					}
				} else {
					this.warning.hide();
				}

				if (!this.options.noValidityUi) {
					this.status.html(CKImage('status-' + result.status));

					if (result.status === Verifier.STATUS.VALID) {
						if (this.dom.find('input, select')) {
							this.dom.find('input, select').addClass('verified');

							this.dom.find('input, select').removeClass('error');
						}
					} else if (result.status !== Verifier.STATUS.NEUTRAL) {
						if (this.dom.find('input, select')) {
							this.dom.find('input, select').removeClass('verified');
							this.dom.find('input, select').addClass('error');
						}
					}
				}
			}

			this.publish('verify', result);
		},

		validityIsAtLeast: function(validity) {
			switch (validity) {
				case Verifier.STATUS.INVALID:
					return true;

				case Verifier.STATUS.NEUTRAL:
					return (
						this._validity === undefined ||
						_.get(this._validity, 'status') !== Verifier.STATUS.INVALID
					);

				case Verifier.STATUS.VALID:
					if (!this.isActive()) {
						return true;
					}

					{
						let validity = _.get(this._validity, 'status');

						if (
							Verifier.isInstance(this.validate) &&
							!this.validate.required &&
							validity !== Verifier.STATUS.INVALID
						) {
							return true;
						}
						return validity === Verifier.STATUS.VALID;
					}

				default:
					CK.logger.warn('Unknown validity', validity);
			}
		},

		setValue: function(value, ignoreUpdate) {
			switch (this.elementType) {
				case ELEMENT_TYPES.CHECKBOX:
					if (value) {
						this.inputElement.addClass('selected');
					} else {
						this.inputElement.removeClass('selected');
					}

					break;

				case ELEMENT_TYPES.RADIO:
					if (value) {
						this.radioButton.addClass('selected');
					} else {
						this.radioButton.removeClass('selected');
					}

					// TODO: Select siblings in the same group

					break;

				case ELEMENT_TYPES.DATE:
					value = new Date(value);
					this.yearElement.val(value.getFullYear());
					this.monthElement.val(value.getMonth());
					this.dayElement.val(value.getDate());

					break;

				case ELEMENT_TYPES.FILE:
					// Value cannot be set for file inputs

					break;

				case ELEMENT_TYPES.SPINNER:
					this.number.html(value);
					break;

				default:
					this.inputElement.val(value);

					break;
			}

			// Validate

			if (!ignoreUpdate) {
				this.onChange();
			}
		},

		getValue: function() {
			if (this.value) {
				return this.value;
			}

			switch (this.elementType) {
				case ELEMENT_TYPES.CHECKBOX:
					return this.inputElement.hasClass('selected');

				case ELEMENT_TYPES.SPINNER:
					return +this.number.html();

				case ELEMENT_TYPES.DATE:
					if (
						this.monthElement.val() === null ||
						+this.yearElement.val() === 0 ||
						!this.dayElement.val()
					) {
						return;
					}

					var year = +this.yearElement.val(),
						month = +this.monthElement.val() + 1,
						day = +this.dayElement.val();

					// Allow shorthand
					if (year < 100) {
						const yearThisCentury = new Date().getFullYear() % 100;
						const thisCentury = new Date().getFullYear() - yearThisCentury;

						if (year < yearThisCentury) {
							year += thisCentury;
						} else {
							year += thisCentury - 100;
						}
					}

					var date = moment(
						year + '-' + _.padStart(month, 2, '0') + '-' + _.padStart(day, 2, '0'),
						'YYYY-MM-DD',
						true
					);

					if (!date.isValid()) {
						return null;
					}

					return date.toDate();

				case ELEMENT_TYPES.RADIO:
					return this.radioButton.hasClass('selected');

				case ELEMENT_TYPES.FILE:
					return this.inputElement[0].files[0];

				case ELEMENT_TYPES.EMAIL:
					return _.trim(this.inputElement.val());

				default:
					return this.inputElement.val();
			}
		},

		type: 'ValidatedInput'
	}
));

ValidatedInput.ELEMENT_TYPES = ELEMENT_TYPES;
ValidatedInput.DEBOUNCE_INTERVAL = 200;
